export default __webpack_public_path__ + "static/media/eurelien.b9ddba01.png";